import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const SettingsBoltNutIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M1.70983 4.24072L7.42411 0.90739C7.77995 0.699815 8.21998 0.699815 8.57582 0.90739L14.2901 4.24072C14.6412 4.44553 14.8571 4.82142 14.8571 5.2279V10.7722C14.8571 11.1787 14.6412 11.5546 14.2901 11.7594L8.57582 15.0927C8.21998 15.3003 7.77995 15.3003 7.42411 15.0927L1.70983 11.7594C1.35872 11.5546 1.14282 11.1787 1.14282 10.7722V5.2279C1.14282 4.82142 1.35872 4.44553 1.70983 4.24072Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.14282 7.99997C5.14282 8.75773 5.44384 9.48445 5.97966 10.0203C6.51548 10.5561 7.2422 10.8571 7.99996 10.8571C8.75773 10.8571 9.48445 10.5561 10.0203 10.0203C10.5561 9.48445 10.8571 8.75773 10.8571 7.99997C10.8571 7.2422 10.5561 6.51548 10.0203 5.97966C9.48445 5.44384 8.75773 5.14282 7.99996 5.14282C7.2422 5.14282 6.51548 5.44384 5.97966 5.97966C5.44384 6.51548 5.14282 7.2422 5.14282 7.99997Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
